import { useEffect, useRef } from 'react';

const useSubscription = (f, hookEffects) => {
  const { subscriber, onDataReceived, onError } = f();
  const subscriptionRef = useRef();

  const connectWebSocketToSubscription = (onUnsubscribe = () => {}) => {
    const callback = subscriber();
    const unsubscribe = callback && callback((result) => onDataReceived(result), onError);
    return () => {
      if (unsubscribe) {
        unsubscribe();
        onUnsubscribe();
      }
    };
  };

  const connect = () => {
    subscriptionRef.current = connectWebSocketToSubscription(() => {
      // preventing multiple un-subscriptions
      subscriptionRef.current = undefined;
    });
  };

  useEffect(() => {
    connect();
  }, hookEffects || []);

  const disconnect = () => {
    // disconnect the websocket
    const unsubscribeF = subscriptionRef.current;
    if (unsubscribeF) {
      unsubscribeF();
    }
  };

  const reconnect = () => {
    // try to disconnect first, then reconnect it again
    disconnect();

    // https://github.com/awslabs/aws-mobile-appsync-sdk-js/issues/501
    // this issue appears sometime when connecting and disconnecting at the same time before the
    // previous session was flushed.
    setTimeout(() => {
      connect();
    }, 1000);
  };

  return [
    {
      disconnect,
      reconnect,
    },
  ];
};

export default useSubscription;
